// src/Camera.js
import React, { useRef, useState, useEffect } from 'react';
import Webcam from 'react-webcam';
import { Link, useParams,useNavigate  } from 'react-router-dom';
import fx from 'glfx';
import { IoRepeat } from "react-icons/io5";
import { PiWarningLight } from 'react-icons/pi'

import { sendAnalyticsData } from '../utilities/analytics';
// import {setStateValue,removeStateValue} from './BrowserHistory.js'

const Camera = (props, {hint}) => {
  const [initCamera, setInitCamera] = useState(false);
  const [cameraAccessBlocked, setCameraAccessBlocked] = useState(false);
  const [lowLightDetected, setLowLightDetected] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [resolution, setResolution] = useState({width: 1280, height: 1280})
  const [timerStart, setTimerStart] = useState(false);
  const [facingMode, setFacingMode] = useState("user");

  
  const [progress, setProgress] = useState(0);
  const [currentTextIndex, setCurrentTextIndex] = useState(4);
  const texts = ["Scanning lips completed", "Scanning nose completed", "Scanning eye completed", "Scanning hair completed", "Scanning..."];

  const webcamRef = useRef(null);
  const outputCanvasRef = useRef(null);
  
  const { type } = useParams();
  const videoConstraints = {
    width: 1280,
    height: 1280,
    facingMode: facingMode
  };

  const switchCamera = () => {
    if (facingMode == 'user') {
      setFacingMode('environment')
      document.querySelector('.video').classList.add("env-mode");
    } else {
      setFacingMode('user')
      document.querySelector('.video').classList.remove("env-mode");
    }
  }
  
  const startCapture = () => {
    sendAnalyticsData('Click','Photo Button')
    setTimerStart(true)
  }

  // const getEnlightenedImage = (sourceImage, gammaTransform) => {
  //   const tgtCv = document.createElement('canvas');
  //   tgtCv.width = sourceImage.width;
  //   tgtCv.height = sourceImage.height;
  //   const context = tgtCv.getContext('2d');
  //   context.drawImage(sourceImage, 0, 0);
  
  //   const imgData = context.getImageData(0, 0, sourceImage.width, sourceImage.height);
  //   const pix = imgData.data;
  //   const gammaInvert = 1 / gammaTransform;
  //   const hslValue = { h: 0, s: 0, l: 0 };
  //   const rgbValue = { r: 0, g: 0, b: 0 };
  
  //   for (let i = 0; i < pix.length; i += 4) {
  //     rgbToHsl(pix[i], pix[i + 1], pix[i + 2], hslValue);
  //     hslValue.l = Math.pow(hslValue.l, gammaInvert);
  //     hslToRgb(hslValue.h, hslValue.s, hslValue.l, rgbValue);
  //     pix[i] = rgbValue.r;
  //     pix[i + 1] = rgbValue.g;
  //     pix[i + 2] = rgbValue.b;
  //   }
  //   context.putImageData(imgData, 0, 0);
  
  //   const newImage = new Image();
  //   newImage.src = tgtCv.toDataURL("image/png");
  //   return newImage;
  // };
  
  // Lighting check and frame processing
  const checkLighting = () => {
    let minBrightness = 0;

    setTimeout(() => {
      const video = document.querySelector('.video');
      if (video) {
        const canvas = document.createElement("canvas");
        canvas.width = videoConstraints.width;
        canvas.height = videoConstraints.height;
        const context = canvas.getContext("2d");
  
        // Calculate center 50% dimensions
        const centerWidth = canvas.width * 0.22;
        const centerHeight = canvas.height * 0.32;
        const startX = (canvas.width - centerWidth) / 2;
        const startY = (canvas.height - centerHeight) / 2;

        // Adjust the Y position of the cropping region (shift down by 20px
        let yOffset = 20; // Shift down by 20px (adjust as needed)

        // for LED only
        // if(document.body.offsetWidth === 720 && document.body.offsetHeight <= 1193){
        //   minBrightness = 78;
        //   yOffset = 232;
        //   console.log(document.body.offsetWidth);
        // }

        const adjustedStartY = startY - yOffset;
  
        // Draw the video to the canvas (full frame)
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
        // Extract the center portion from the canvas with adjusted Y position
        const centerCanvas = document.createElement("canvas");
        centerCanvas.width = centerWidth;
        centerCanvas.height = centerHeight;
        const centerContext = centerCanvas.getContext("2d");
        centerContext.drawImage(canvas, startX, adjustedStartY, centerWidth, centerHeight, 0, 0, centerWidth, centerHeight);
  
        // Get image data for the center portion
        const frame = centerContext.getImageData(0, 0, centerWidth, centerHeight);
  
        // Calculate average brightness for lighting detection
        let totalBrightness = 0;
        for (let i = 0; i < frame.data.length; i += 4) {
          const brightness = (frame.data[i] + frame.data[i + 1] + frame.data[i + 2]) / 3;
          totalBrightness += brightness;
        }
  
        const avgBrightness = totalBrightness / (frame.data.length / 4);

        setLowLightDetected(avgBrightness < minBrightness); // Adjust threshold if needed
  
        // Add a one-time click event for downloading the image
        // document.body.addEventListener("click", () => {
        //   const dataUrl = centerCanvas.toDataURL("image/png");

        //   // Create a temporary anchor element
        //   const link = document.createElement("a");
        //   link.href = dataUrl;
        //   link.download = "center-image.png"; // Filename for the downloaded image
        //   document.body.appendChild(link); // Append the link to the document
        //   link.click(); // Trigger the download
        //   document.body.removeChild(link); // Clean up by removing the link
        // }, { once: true });
      }
    }, 0);
  };

  // const rgbToHsl = (R, G, B, res) => {
  //   var var_R = (R / 255); //RGB from 0 to 255
  //   var var_G = (G / 255);
  //   var var_B = (B / 255);

  //   var H = 0,
  //       S = 0,
  //       L = 0;

  //   var var_Min = Math.min(var_R, var_G, var_B); //Min. value of RGB
  //   var var_Max = Math.max(var_R, var_G, var_B); //Max. value of RGB
  //   var del_Max = var_Max - var_Min; //Delta RGB value

  //   L = (var_Max + var_Min) / 2;

  //   if (del_Max === 0) { //This is a gray, no chroma...
  //       H = 0; //HSL results from 0 to 1
  //       S = 0;
  //   } else { //Chromatic data...    
  //       S = (L < 0.5) ? del_Max / (var_Max + var_Min) : del_Max / (2 - var_Max - var_Min);


  //       var del_R = (((var_Max - var_R) / 6) + (del_Max / 2)) / del_Max;
  //       var del_G = (((var_Max - var_G) / 6) + (del_Max / 2)) / del_Max;
  //       var del_B = (((var_Max - var_B) / 6) + (del_Max / 2)) / del_Max;

  //       if (var_R === var_Max) {
  //           H = del_B - del_G;
  //       } else if (var_G === var_Max) {
  //           H = (1 / 3) + del_R - del_B;
  //       } else if (var_B === var_Max) {
  //           H = (2 / 3) + del_G - del_R;
  //       }

  //       if (H < 0) H += 1;
  //       if (H > 1) H -= 1;
  //   }
  //   res.h = H;
  //   res.s = S;
  //   res.l = L;
  // };

  // const hslToRgb = (H, S, L, res) => {
  //   var R = 0,
  //       G = 0,
  //       B = 0;
  //   var var_1 = 0,
  //       var_2 = 0;

  //   if (S === 0) { //HSL from 0 to 1
  //       R = L * 255; //RGB results from 0 to 255
  //       G = L * 255;
  //       B = L * 255;
  //   } else {
  //       var_2 = (L < 0.5) ? L * (1 + S) : (L + S) - (S * L);
  //       var_1 = 2 * L - var_2

  //       R = 255 * hueToRgb(var_1, var_2, H + (1 / 3));
  //       G = 255 * hueToRgb(var_1, var_2, H);
  //       B = 255 * hueToRgb(var_1, var_2, H - (1 / 3));
  //   }
  //   res.r = R;
  //   res.g = G;
  //   res.b = B;
  // };

  // const hueToRgb = (v1, v2, vH) => {
  //   if (vH < 0) vH += 1;
  //   if (vH > 1) vH -= 1;
  //   if ((6 * vH) < 1) return (v1 + (v2 - v1) * 6 * vH);
  //   if ((2 * vH) < 1) return (v2);
  //   if ((3 * vH) < 2) return (v1 + (v2 - v1) * ((2 / 3) - vH) * 6);
  //   return (v1);
  // };

  const checkCameraAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      let stream_settings = stream.getVideoTracks()[0].getSettings();
      let smaller = Math.min(stream_settings.width, stream_settings.height);
  
      if (smaller > 720) {
        setResolution({ width: 1280, height: 1280 });
      } else if (smaller <= 600) {
        setResolution({ width: 720, height: 720 });
        videoConstraints.width = smaller;
        videoConstraints.height = smaller;
      } else {
        setResolution({ width: 720, height: 720 });
        videoConstraints.width = 720;
        videoConstraints.height = 720;
      }
  
      stream.getTracks().forEach((track) => track.stop());
  
      setInitCamera(true);
      setCameraAccessBlocked(false);
  
      sendAnalyticsData('Click', 'Allowed Camera');
    } catch (error) {
      handleCameraError(error);
    }
  };
  
  const handleCameraError = (error) => {
    switch (error.name) {
      case 'NotAllowedError':
        sendAnalyticsData('Click', 'Not Allowed Camera');
        setCameraAccessBlocked(true);
        break;
      case 'NotFoundError':
        console.error("No camera devices found.");
        break;
      case 'NotReadableError':
        console.error("Camera is currently unavailable (possibly in use by another application).");
        break;
      case 'OverconstrainedError':
        console.error("The specified camera constraints cannot be met.");
        break;
      case 'SecurityError':
        console.error("Security policy prevented access to the camera.");
        break;
      default:
        // Catch-all for other camera-related errors
        console.error("An unknown error occurred while accessing the camera:", error);
        break;
    }
    setCameraAccessBlocked(true);
  };
  
  useEffect(() => {
    if(initCamera){
      const lightingInterval = setInterval(checkLighting, 100);
      return () => clearInterval(lightingInterval);
    }
  }, [initCamera])

  useEffect(() => {
    let interval;

    if (timerStart) {
      interval = setInterval(() => {
        setCurrentTextIndex((prevTimerText) => {
          if (prevTimerText === 0) {
            clearInterval(interval); // Clear the interval when timerText reaches zero

            return 0;
          } else {
            return prevTimerText - 1;
          }
        });
      }, 1000*2.3);
    }

    return () => {
      clearInterval(interval); // Clear the interval when the component unmounts
    };

    
  }, [timerStart]);

  useEffect(() => {
    let progressInterval;
  
    if (timerStart) {
      if (progress < 100) {
        progressInterval = setInterval(() => {
          setProgress((prev) => Math.min(prev + 1, 100));
        }, 100);
      } else {
        captureImage();
      }
    }
  
    return () => {
      clearInterval(progressInterval);
    };
  }, [progress, timerStart]);
  

  useEffect(() => {
    checkCameraAccess();
  }, []);

  const captureImage = () => {
    setTimerStart(false);
    if (webcamRef.current) {
      const imageCaptured = webcamRef.current.getScreenshot(); // Capture the image
  
      const outputCanvas = outputCanvasRef.current;
  
      // Ensure the canvas dimensions match the video resolution
      outputCanvas.width = videoConstraints.width;
      outputCanvas.height = videoConstraints.height;
  
      const outCtx = outputCanvas.getContext('2d');
  
      // Clear the previous canvas data
      outCtx.clearRect(0, 0, videoConstraints.width, videoConstraints.height);
  
      // Create an image from the captured screenshot and draw it on the output canvas
      const image = new Image();
      image.src = imageCaptured;
  
      image.onload = () => {
        outCtx.drawImage(image, 0, 0, videoConstraints.width, videoConstraints.height);
  
        // Get the image data for processing
        const frame = outCtx.getImageData(0, 0, videoConstraints.width, videoConstraints.height);
  
        // Initialize glfx canvas for applying the denoise effect
        const fxCanvas = fx.canvas();
        const fxTexture = fxCanvas.texture(frame);
        
        // Apply denoise filter and update the effect
        fxCanvas.draw(fxTexture).denoise(110).update();
  
        // Get the processed image and draw it on the output canvas
        const filteredImage = fxCanvas.toDataURL();
        const filteredImageElement = new Image();
        filteredImageElement.src = filteredImage;
  
        // Once the filtered image is loaded, draw it on the output canvas
        filteredImageElement.onload = () => {
          outCtx.clearRect(0, 0, videoConstraints.width, videoConstraints.height);
          outCtx.drawImage(filteredImageElement, 0, 0, videoConstraints.width, videoConstraints.height);
  
          // Set the filtered image as source for state
          setImageSrc(filteredImage); // Update state with filtered image
          console.log(`Finish process`);
          sendAnalyticsData('Click', 'Photo Taken');
          setInitCamera(false);
        };
      };
    }
  };

  const retakeEvent = () => {
    checkCameraAccess();
    sendAnalyticsData('Click','Retake Photo')
    setImageSrc(null);
    setTimerStart(false);
    setCurrentTextIndex(4);
    setProgress(0);
  }

  useEffect(() => {
    if(lowLightDetected){
      setTimerStart(false)
      setCurrentTextIndex(4);
      setProgress(0);
    }
  })

  return (
    <>
      {
      !imageSrc ?
        <div className={timerStart ? 'camera-wrapper d-flex justify-content-center align-items-center scanning' : 'camera-wrapper d-flex justify-content-center align-items-center'}>
          {props.children}
          <img className='face-outline' src='/images/face-outline.png' alt='face outline'/>
          <img className='face-outline face-outline-scanning' src='/images/face-outline.png' alt='face outline'/>
            {
            !timerStart && !cameraAccessBlocked && !lowLightDetected ?
            <div href class="btn capture-button" onClick={startCapture}>Start Scan</div>
          :
          null}
          {timerStart &&
            (
              <div className="gimmick-scanner">
                <div className="scanner-text">
                  <p className="fade-text">{texts[currentTextIndex]}</p>
                </div>
                <div className="progress-bar">
                  <div className="progress" style={{ width: `${progress}%` }}></div>
                </div>
              </div>
            )}

          {/* <div className="lighting-detect">Avg. Lighting <br/> {brightnessValue.toFixed(0)}</div> */}
          
          {cameraAccessBlocked ? (
            <p className='camera-blocked'>
              <span><PiWarningLight/></span>
              Camera not found or it access is blocked, Please allow camera access in your browser settings.
              <a className='btn d-table mx-auto btn-primary btn-outline mt-3 font-small' onClick={()=>{checkCameraAccess()}}>Retry</a>
            </p>
          ) : 
            initCamera ? 
            (
              <>
                <Webcam
                  className='video'
                  audio={false}
                  ref={webcamRef}
                  minScreenshotHeight={resolution.height}
                  minScreenshotWidth={resolution.width}
                  mirrored={true}
                  screenshotFormat="image/jpeg"
                  videoConstraints={videoConstraints}
                />
                
                <canvas ref={outputCanvasRef} id="output"></canvas>

                {lowLightDetected && <div className="lighting-detect">Lighting too dark</div>}
              </>
            )
            :
              null
          }
          <div className='footer-bar-wrapper'>
            <div className='camera-bottom-text d-table mx-auto'>Please align your face in the oval above</div>
            {
            !timerStart && !cameraAccessBlocked && !lowLightDetected ?
            <>
              {/* <div onClick={startCapture} className="capture-button capture-button-bordered d-flex justify-content-center align-items-center"></div> */}
              {/* <div onClick={switchCamera} style={{left: '90%'}} className={`capture-button bg-transparent d-flex justify-content-center align-items-center`}>
                <IoRepeat style={{fontSize: '32px'}}/>
              </div> */}
            </>
            :
            null
            }
          </div>
        </div>
        :
        <div className='captured-wrapper'>
          <div className='captured-wrapper-inner'>
            <img className='image-captured' src={imageSrc} alt="Captured" />
          </div>
          <div className='captured-action d-flex flex-column mt-2 mt-md-3'>
            <a className='btn btn-primary d-table mx-auto mb-2 mb-md-3 w-100' onClick={retakeEvent}>
              Retake
            </a>
            {/* <Link className='btn btn-primary d-table mx-auto w-100' onClick={() => {sendAnalyticsData('Click','Go To SkinTone Page')}} to={`/${type}/result`} state={{photo: brighterCanvas ? canvasVideo : imageSrc}}>Next</Link> */}
            <Link className='btn btn-primary d-table mx-auto w-100' onClick={() => {sendAnalyticsData('Click','Go To SkinTone Page')}} to={`/${type}/result`} state={{photo: imageSrc}}>Next</Link>
          </div>
        </div>
      }
    </>
  );
};

export default Camera;
